// -*- coding: utf-8 -*-
import React from 'react';

// WhatsApp-style delivery ticks
// sent -> 1 gray tick
// delivered -> 2 gray ticks
// read -> 2 blue ticks
// pending -> clock
// failed -> warning triangle

export default function MessageStatusTicks({ status, size = 14, grey = '#8696A0', blue = '#53bdeb', failed = '#e74c3c', titleMap }) {
  const s = normalizeStatus(status);
  const label = (titleMap && titleMap[s]) ||
    (s === 'read' ? 'Okundu' : s === 'delivered' ? 'Ulaştırıldı' : s === 'sent' ? 'Gönderildi' : s === 'pending' ? 'Kuyrukta' : s === 'failed' ? 'Gönderilemedi' : 'Durum belirsiz');

  if (s === 'pending') {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', color: grey }} title={label} aria-label={label}>
        <ClockIcon size={size} />
      </span>
    );
  }
  if (s === 'failed' || s === 'unknown') {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', color: failed }} title={label} aria-label={label}>
        <WarnIcon size={size} />
      </span>
    );
  }

  const color = s === 'read' ? blue : grey;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', color }} title={label} aria-label={label}>
      {s === 'sent' ? <SingleTick size={size} /> : <DoubleTick size={size} />}
    </span>
  );
}

export function normalizeStatus(status) {
  if (!status) return 'unknown';
  const s = String(status).toLowerCase();
  if (s === 'read') return 'read';
  if (s === 'delivered') return 'delivered';
  if (s === 'sent' || s === 'accepted' || s === 'submitted') return 'sent';
  if (s === 'pending' || s === 'queued') return 'pending';
  if (s === 'failed' || s === 'error') return 'failed';
  return 'unknown';
}

function SingleTick({ size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" aria-hidden="true">
      <path d="M3 9.5 L6.5 12.5 L13 4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function DoubleTick({ size }) {
  return (
    <svg width={size + 2} height={size} viewBox="0 0 20 16" aria-hidden="true">
      <path d="M1.5 9.5 L5 12.5 L11 4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.85" />
      <path d="M7 9.5 L10.5 12.5 L18.5 3.5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function ClockIcon({ size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" aria-hidden="true">
      <circle cx="8" cy="8" r="6.5" fill="none" stroke="currentColor" strokeWidth="2" />
      <path d="M8 4.5 L8 8 L11 9.5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

function WarnIcon({ size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" aria-hidden="true">
      <path d="M8 1.5 L14.5 13 H1.5 Z" fill="none" stroke="currentColor" strokeWidth="2" />
      <rect x="7.25" y="5" width="1.5" height="5" rx="0.75" fill="currentColor" />
      <circle cx="8" cy="12.5" r="1" fill="currentColor" />
    </svg>
  );
}
